import { render, staticRenderFns } from "./ServerUserDetail.vue?vue&type=template&id=5cfffb07&scoped=true&"
import script from "./ServerUserDetail.vue?vue&type=script&lang=js&"
export * from "./ServerUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServerUserDetail.vue?vue&type=style&index=0&id=5cfffb07&lang=scss&scoped=true&"
import style1 from "./ServerUserDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfffb07",
  null
  
)

export default component.exports